import { Spin, CheckCircleFilled } from '@fx-ui/fine-design';
import classNames from 'classnames';
import { FC, useEffect, useRef, useState } from 'react';
import { platformIntl } from '../../../../constants';

const ConfigLine: FC<{
    className?: string;
    loading?: boolean;
    label: string;
    content: React.ReactNode;
}> = ({ className, loading, label, content }) => {
    const [showSuccess, setShowSuccess] = useState(false);
    const prevLoadingRef = useRef(loading);
    const timerRef = useRef<NodeJS.Timeout>();

    useEffect(() => {
        if (prevLoadingRef.current === true && loading === false) {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            setShowSuccess(true);
            timerRef.current = setTimeout(() => {
                setShowSuccess(false);
            }, 2000);
        } else if (loading === true) {
            setShowSuccess(false);
        }
        prevLoadingRef.current = loading;
    }, [loading]);

    return (
        <div className={classNames('fx-config-line', className)}>
            <div className="config-label">{label}</div>
            <div className="config-content">{content}</div>
            <div
                className={classNames('config-tip', {
                    success: showSuccess,
                    hidden: !loading && !showSuccess
                })}
            >
                {showSuccess ? (
                    <CheckCircleFilled className="tip-icon" />
                ) : (
                    <Spin size="small" className="tip-icon" />
                )}
                {showSuccess ? (
                    <span>{platformIntl.get('fxp.base.bg.admin.saved_modify.tip')}</span>
                ) : (
                    <span>{platformIntl.get('fxp.base.bg.admin.modifying.tip')}</span>
                )}
            </div>
        </div>
    );
};

export default ConfigLine;
